import { defineMessages } from "react-intl";

const messages = defineMessages({
  cardTitle: {
    id: "dashboard.cards.openStageDealAmount.title",
    defaultMessage: "Deal Amount",
    description: "Title of the Deal Amount card",
  },
  modalTitle: {
    id: "dashboard.editModal.openStageDealAmount.title",
    defaultMessage: "Edit “Open Stage Deal Amount”",
    description: "Title of the Edit Deal Amount modal",
  },
});

export default messages;
